import { EmployeeExpenseRowTypeModelType } from '@teinor/erp/types/company/userInner/employee/employeeExpense/employeeExpenseRow/employeeExpenseRowType'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import TwinTable from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { EditRowNotLink } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalCEExpenseType from './ModalCEExpenseType'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'


interface ExpensesTypesProps extends ComponentWithPermissions { }

const ExpensesTypes: React.FC<ExpensesTypesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('expensesTypes', 'Tipos de gastos'),
        newText: t('newExpenseType', 'Nuevo tipo de gasto'),
    }

    return (
        <BaseScreenTable TableComponent={TableExpensesTypes} CreateModalComponent={ModalCEExpenseType} EditModalComponent={ModalCEExpenseType} pageData={pageData} userPermissions={userPermissions} />
    )
}

type TableExpensesTypesProps = TableComponentProps & {}

const TableExpensesTypes: React.FC<TableExpensesTypesProps> = ({ setTableInstance, setOpened, userPermissions }) => {
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<EmployeeExpenseRowTypeModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'update')
        },
    ]
    return (
        <TwinTable name='expensesTypes' columns={columns} getDataFrom='/api/app/employeeExpense/getAllEmployeeExpensesRowType' onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })} setTableInstance={setTableInstance} />
    )
}

export default ExpensesTypes